import { LogIn } from 'lucide-react';
import { type OfferedSSO, ssoStartURL } from '@/lib/api';
import { cn } from '@/lib/classnames';

// SSOButtons - one "Sign in with <label>" per organization whose single
// sign-on is offered. Plain links rather than buttons: the start route answers
// with a redirect to the identity provider, which a full navigation follows.
//
// A lone button is the page's primary action. Several are alternatives of one
// weight, so none of them is.
export function SSOButtons({ offered, returnPath }: { offered: OfferedSSO[]; returnPath: string }) {
  const variant = offered.length === 1 ? 'btn-primary' : 'btn-secondary';
  return (
    <div className="flex flex-col gap-3">
      {offered.map((o) => (
        <a key={o.org_id} href={ssoStartURL(o.org_id, returnPath)} className={cn(variant, 'w-full justify-center')}>
          <LogIn className="w-4 h-4" aria-hidden />
          Sign in with {o.label}
        </a>
      ))}
    </div>
  );
}
